/// <reference path="../../../app.definition.ts" />
interface INgRepeatCompleteScope extends ng.IScope {
    ngRepeatComplete: () => void;
}
interface INgRepeatScope extends ng.IScope {
    $last: boolean;
}

function ngRepeatComplete(): ng.IDirective {
    return {
        restrict: 'A',
        scope: {
            'ngRepeatComplete': '&'
        },
        link: (scope: INgRepeatCompleteScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes): void => {
            const parentScope = scope.$parent as INgRepeatScope;

            if (parentScope.$last) {
                // The timeout ensures the callback fires after the DOM is truly updated.
                scope.$evalAsync(() => {
                    scope.ngRepeatComplete();
                });
            }
        }
    };
}
angular.module('eCareVault.common.directives').directive('ngRepeatComplete', ngRepeatComplete);
